'use strict';

angular.module('schoolbushubApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('notifications', {
                parent: 'admin',
                url: '/notifications',
                data: {
                    authorities: ['ROLE_SEONADMIN', 'ROLE_ADMIN', 'ROLE_CUSTOMERADMIN'],
                    pageTitle: 'audits.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/admin/notifications/notifications.html',
                        controller: 'notificationsController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('notifications');
                        return $translate.refresh();
                    }]
                }
            });
    });
